"use strict";
// Copyright © 2021 Move Closer
Object.defineProperty(exports, "__esModule", { value: true });
exports.HTMLAdapter = void 0;
const demarked_1 = require("@d24/demarked");
const adapter_1 = require("../_abstract/adapter");
const _contracts_1 = require("../_contracts");
const adapter_2 = require("../_helpers/adapter");
/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
class HTMLAdapter extends adapter_1.AbstractAdapter {
    /**
     * Adapts (translates/maps) the passed-in `HTMLModule` to the `HTMLToken`.
     *
     * @param object - The module to adapt.
     */
    objectToToken(object) {
        this.validate(object, {
            'content.html': {
                presence: true,
                type: 'string'
            }
        });
        if (typeof object.content.scripts !== 'undefined') {
            this.validate(object, {
                'content.scripts': {
                    type: 'array'
                }
            });
            object.content.scripts.forEach(script => {
                this.validate(script, {
                    src: {
                        presence: true,
                        type: 'string'
                    }
                });
            });
        }
        const token = {
            content: object.content.html,
            raw: object.content.html,
            type: demarked_1.TokenType.HTML
        };
        const scripts = object.content.scripts;
        if (typeof scripts !== 'undefined' && Array.isArray(scripts) && scripts.length > 0) {
            token.meta = { scripts };
            scripts.forEach(script => {
                const attrs = Object.entries(script).reduce((acc, [key, value]) => {
                    return `${acc} ${key}${typeof value !== 'undefined' ? `="${value}"` : ''}`;
                }, '');
                token.raw += `<script${attrs}></script>`;
            });
        }
        return token;
    }
    /**
     * Adapts (translates/maps) the passed-in `HTMLToken` to the `HTMLModule`.
     *
     * @param token - The token to adapt.
     */
    tokenToObject(token) {
        this.validate(token, {
            content: {
                presence: true,
                type: 'string'
            }
        });
        if (typeof token.meta !== 'undefined' && typeof token.meta.scripts !== 'undefined') {
            this.validate(token.meta, {
                scripts: {
                    type: 'array'
                }
            });
            token.meta.scripts.forEach(script => {
                this.validate(script, {
                    src: {
                        presence: true,
                        type: 'string'
                    }
                });
            });
        }
        const module = {
            ...adapter_2.getModuleBase(),
            content: {
                html: token.content
            },
            driver: _contracts_1.ModuleDriver.HTML
        };
        if (typeof token.meta !== 'undefined' && typeof token.meta.scripts !== 'undefined') {
            module.content.scripts = token.meta.scripts;
        }
        return module;
    }
}
exports.HTMLAdapter = HTMLAdapter;
//# sourceMappingURL=HTML.adapter.js.map